import { Module } from 'vuex'

import { PostReviewUseCase } from '@/application/reviewPost/postReviewUseCase'
import { ReviewPostRepository } from '@/domain/repositories/reviewPost/reviewPostRepository'

interface PostReviewState {
  reviewList: { [entryId: string]: string }
  isLoading: boolean
  error: Error | null
}

export const postReviewModule = (reviewEntryRepository: ReviewPostRepository): Module<PostReviewState, any> => {
  const postReviewUseCase = new PostReviewUseCase(reviewEntryRepository)

  return {
    namespaced: true,
    state: {
      reviewList: {},
      isLoading: false,
      error: null
    },
    mutations: {
      setReviewList(state, { reviewList }: { reviewList: { [entryId: string]: string } }) {
        state.reviewList = reviewList
      },
      setReview(state, { entryId, message }: { entryId: string; message: string }) {
        state.reviewList[entryId] = message
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async postReview(
        { commit },
        { entryId, message, reviewerId }: { entryId: string; message: string; reviewerId: string }
      ) {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          await postReviewUseCase.postReview(entryId, message, reviewerId)
        } catch (e) {
          commit('setError', e)
          commit('setEntryList', [])
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      reviewList: state => state.reviewList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
